import { Injectable } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { map, switchMap, take } from 'rxjs';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { OrderDetailsService } from 'src/app/service/myaccount/order-details.service';

@Injectable({
  providedIn: 'root',
})
export class OrderDetailsAuthGuard {
  constructor(
    private routingService: RoutingService,
    private orderDetailsService: OrderDetailsService,
    private shimanoCountryService: ShimanoCountryService
  ) {}

  get country(): string {
    let country: string;
    this.shimanoCountryService
      .getActive()
      .pipe(take(1))
      .subscribe((data) => (country = data));
    return country;
  }

  canActivate() {
    return this.routingService.getRouterState().pipe(
      switchMap((state) => {
        const orderCode = state.nextState.params.orderCode;
        const erpOrderType = state.nextState.queryParams.erpOrderType ?? '';
        return this.orderDetailsService.getOrderDetails(orderCode, erpOrderType).pipe(
          take(1),
          map((data: any) => {
            if (this.country === 'ca' || this.country === 'us') {
              if (!data.hasOwnProperty('code')) {
                this.routingService.goByUrl('/not-found');
              }
            }
          })
        );
      })
    );
  }
}
